import styled from "styled-components";

export const OnboardingDialogSecondaryTextDefaultBox = styled.div`
    font-size: 1.6rem;
    margin-top: 1rem;
    line-height: 1.2;
    ${({theme}) => theme.font.presets.regular}
    color: ${({theme}) => theme.colors.textLight};
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        font-size: 1.4rem;
        margin-top: 0.5rem;
    }
`;
